import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import TauriHostContainer from '../TauriHostContainer/TauriHostContainer';
import config from '../../config.json';
import { getData } from '../../visualizations/visualizations';
import './TauriDashboard.css';

const TauriDashboard = () => {
    const [itemSections, setItemSections] = useState([]);
    const [chartPalettes, setChartPalettes] = useState([]);
    const [chartThemes, setChartThemes] = useState([]);
    const [userLevel, setUserLevel] = useState(null);
    const [hasAccess, setHasAccess] = useState(null);

    const { id } = useParams();

    const ACCESS_TYPE_MAP = {
        customers: { type: "customers", value: 8 },
        agents: { type: "agents", value: 1 },
        districts: { type: "districts", value: 2 },
        territories: { type: "territories", value: 0 },
        distributors: { type: "distributors", value: 3 },
        regions: { type: "regions", value: 4 },
        executive: { type: "executives", value: 5 },
        items: { type: "items", value: 10 },
    };

    useEffect(() => {
        const idNumber = parseInt(id);

        const fetchData = async () => {
            const getUserData = localStorage.getItem('UserData');
            const decodedUserData = JSON.parse(atob(getUserData));

            const getPermission = localStorage.getItem('permission');
            const decodedPermission = JSON.parse(atob(getPermission));

            const access = decodedPermission?.DataScope?.Access;

            setUserLevel(access);

            const accessResult = Array.isArray(decodedUserData.CodeList) && decodedUserData.CodeList.length > 0;

            setHasAccess(accessResult ? decodedUserData.CodeList : false);

            const data = getData(id.toString(), access ? access.toString() : '-1');
            const colorsheme = getData('colorScheme', access ? access.toString() : '-1');

            setItemSections(data.sections);
            setChartPalettes(colorsheme.palettes);
            setChartThemes(colorsheme.themes);
        };

        fetchData();

    }, [id]);

    return userLevel == ACCESS_TYPE_MAP.executive.value || hasAccess ? (
        <TauriHostContainer
            itemSection={itemSections}
            chartPalette={chartPalettes}
            chartTheme={chartThemes}
        />
    ) : (
        <div className="tauri-dashboard d-flex flex-column justify-content-center align-items-center h-100">
            <div className="dashboard-messagebox d-flex flex-column justify-content-center align-items-center">
                <p className="noaccess-title">NO ACCESS!</p>
                <p className="noaccess-message">Please contact your administrator for your access.</p>
            </div>
        </div>
    );
};

export default TauriDashboard